module.exports = __webpack_public_path__ + "static/media/newBorn.d378dba1.jpg";